<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div id="wish-list">
        <div class="wish-list-grid">
          <div
            class="wish-item"
            v-for="item in showList"
            @click="goToDetail(item)"
          >
            <div v-if="item.images && item.images.length" class="wish-images">
              <img v-for="(img, idx) in item.images" :key="idx" :src="img" class="wish-img" />
              <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.title" class="wish-img" /> -->
            </div>
            <div class="wish-content">
              <div class="wish-title ells2 CH_6_Bold">{{ item.title }}</div>
              <div v-if="item.remark" class="wish-remark ells3 CH_7_Regular">{{ item.remark }}</div>
            </div>
          </div>
        </div>
        <div v-if="!expanded && wishList.length > 4" class="more-btn-box">
          <div class="more-btn" @click="openExpanded"><span class="EN_6_Regular">{{ $t('common.more') }}</span><span class="JHSicon JHS-arrow_down"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';
declare const jhsapp: any;
interface WishListItem {
  title?: string;
  images?: string[];
  remark?: string;
  link?: string;
  wish_id?: string;
  wish_name?: string;
  miniprogram_link?: string;
}

const props = defineProps<{
  wishList: WishListItem[];
  title: string;  
  module_ID: string;
}>();

const expanded = ref(false);

const showList = computed(() => {
  return expanded.value ? props.wishList : props.wishList.slice(0, 6);
});

const openExpanded = () => {
  checkLoginAndGo(()=>{
    expanded.value = true;
  })
}

// 跳转详情页
const goToDetail = (item: WishListItem) => {
  track('H5Landing_module_operation', {
    operation: 'click_on_link_wishList',
  });

  track('lst_H5Landing_module_wishList', {
    module_ID: props.module_ID,
    module_type: 'link_wishList',
    wishlists: {
      id: item.wish_id,
      name: item.wish_name,
    },
  });

  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else if (item.miniprogram_link) {
        jhsapp.router(item.miniprogram_link);
      }
    } catch (error) {
      console.log("error", error)
    }
  })
};
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

#wish-list {
  width: 100%;
}

.wish-list-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--gap-8) var(--gap-6);
}

.wish-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--gap-5);

  .wish-images {
    position: relative;
    width: 100%;
    max-width: 110px;
    aspect-ratio: 110 / 114;
    margin: 0 auto;
    overflow: hidden;
  }

  .wish-img {
    position: absolute;
    left: 0;
    top: 50%;
    border-radius: 5px;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    background: #fff;
    transition: box-shadow 0.2s;
    transform: translateY(-50%);
  }

  .wish-img:nth-child(n+4) {
    display: none;
  }

  .wish-img:nth-child(1) {
    z-index: 3;
    width: 72.4%;
    height: 99.8%;
    left: 0;
  }
  .wish-img:nth-child(2) {
    z-index: 2;
    width: 67.2%;
    height: 93.2%;
    left: 16.4%;
  }
  .wish-img:nth-child(3) {
    z-index: 1;
    width: 63.8%;
    height: 86.5%;
    left: 32.7%;
  }

  .wish-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--gap-2 );
    align-self: stretch;

    .wish-title {
      color: var(--on-container-text-primary);
    }

    .wish-remark {
      color: var(--on-container-text-thirdry);
    }
  }
}
</style> 